import { render, staticRenderFns } from "./userGroup.vue?vue&type=template&id=0c62e74c&"
import script from "./userGroup.vue?vue&type=script&lang=js&"
export * from "./userGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports